export const enum LicenseEndpoints {
  LICENSE = '/license'
}
